<app-alerts />

<app-admin-box-details-form
  (submitClickEvent)="handleSubmitClickEvent($event)" />
